export function checkVendorPdfType(vendor_entity_id, setType) {
  if (vendor_entity_id == '7864331'
    || vendor_entity_id == '64913410') {
    console.log('setting to type B');
    setType('B');
  }
}

// export default checkVendorPdfType;
